export const GAMES = [
  {
    name: 'Yu-Gi-Oh!',
    slug: 'yugioh',
  },
] as const;

export const DEFAULT_GAME_CODE = GAMES[0].slug;
